// import Vue from "vue";
import axios from "axios";
import { VueAxios } from "./axios";

// 创建 axios 实例
const service = axios.create({
  baseURL: "http://admin.dertparts.com", // api base_url
  timeout: 600000 // 请求超时时间
});

// response interceptor
service.interceptors.response.use(response => {
  return response.data;
});

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service);
  }
};

export { installer as VueAxios, service as axios };
